import type {ColorAdPropertyOptionExtras} from '@frontend/modules/private/ads/MyAdsModuleTypes'
import type {AdPropertyConfigForFilters} from '@frontend/modules/public/ads/AdsModuleTypes'
import {mdiCheckBold} from '@mdi/js'
import clsx from 'clsx'
import {FadeIn} from 'swayok-react-mdb-ui-kit/components/Animation/FadeIn'
import {Icon} from 'swayok-react-mdb-ui-kit/components/Icon/Icon'
import {Tooltip} from 'swayok-react-mdb-ui-kit/components/Tooltip/Tooltip'
import {toggleValueInArray} from 'swayok-react-mdb-ui-kit/helpers/form/toggleValueInArray'
import type {FormSelectOption} from 'swayok-react-mdb-ui-kit/types/Common'
import {FilterLabel} from './FilterLabel'

interface Props {
    config: AdPropertyConfigForFilters
    values: (string | number | null)[]
    onChange: (name: string, values: (string | number | null)[]) => void
    disabled?: boolean
    className?: string
}

// Фильтр выбора нескольких цветов из списка.
export function ColorsFilter(props: Props) {

    const {
        config,
        values = [],
        onChange,
        disabled,
        className = 'pb-3',
    } = props

    const {
        label,
        className: classNameFromConfig,
        options,
    } = config.props

    if (!options) {
        // Нет опций - нечего показывать.
        return null
    }

    // Отрисовка одной опции.
    const renderOption = (option: FormSelectOption<string | number | null>) => (
        <Tooltip
            key={option.value}
            tag="div"
            title={option.label}
            tooltipDisableClickHandler
            className="mx-1 my-2 rounded-circle border clickable position-relative flex-shrink-0"
            style={{
                background: (option.extra as ColorAdPropertyOptionExtras)?.background,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                width: 28,
                height: 28,
            }}
            onClick={() => {
                if (disabled) {
                    return
                }
                onChange(
                    config.name,
                    toggleValueInArray(
                        values,
                        option.value
                    )
                )
            }}
        >
            <FadeIn visible={values.includes(option.value)}>
                <div
                    className="rounded-circle bg-white position-absolute with-icon-flex justify-content-center"
                    style={{
                        width: 17,
                        height: 17,
                        top: 5,
                        left: 5,
                    }}
                >
                    <Icon
                        path={mdiCheckBold}
                        size={14}
                        color="muted"
                    />
                </div>
            </FadeIn>
        </Tooltip>
    )

    return (
        <div
            className={clsx(
                className,
                classNameFromConfig
            )}
        >
            <FilterLabel
                label={label}
                showResetButton={values.length > 0}
                disabled={disabled}
                onReset={() => onChange(config.name, [])}
            />
            <div className="flex-container-row flex-wrap mx-n1 mt-n2">
                {options.map(renderOption)}
            </div>
        </div>
    )
}
